import { Icon } from '@aibees/shared/components';
import { Box, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  flex: 2;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

export const Input = styled(TextField)`
  width: 100%;
  > div {
    display: flex;
    height: ${(p) => p.theme.spacing(4.5)};
    padding: 15px 7px 15px 11px;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    border-radius: ${(p) => p.theme.spacing(0.5)};
    gap: 10px;
  }

  & svg {
    color: ${(p) => p.theme.palette.text.disabled};
    font-size: 24px;
  }
`;

export const CloseIcon = styled(Icon)`
  color: ${(p) => p.theme.palette.grey[500]};
  cursor: pointer;
`;
